import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import API from 'api/index.js';

const initialState = {
    vop: null,
    isPlateless: null,
    car: null,
    isCarConfirmed: false,
    isOwnerConfirmed: false,
    isCertUploaded: false,
    isDone: false,
};

export const operatorRecycleSlice = createSlice({
    name: 'operatorRecycle',
    initialState,
    reducers: {
        reset: state => {
            state.isPlateless = initialState.isPlateless;
            state.car = initialState.car;
            state.isCarConfirmed = initialState.isCarConfirmed;
            state.isOwnerConfirmed = initialState.isOwnerConfirmed;
            state.isCertUploaded = initialState.isCertUploaded;
            state.isDone = initialState.isDone;
        },
        resetVOP: state => { state.vop = initialState.vop; },
        setIsPlateless: (state, { payload }) => { state.isPlateless = payload; },
        setIsCarConfirmed: (state, { payload }) => { state.isCarConfirmed = payload; },
        setIsOwnerConfirmed: (state, { payload }) => { state.isOwnerConfirmed = payload; },
        setIsCertUploaded: (state, { payload }) => { state.isCertUploaded = payload; },
        setIsDone: state => { state.isDone = true; },
        recycleIncomingCar: (state, { payload }) => {
            state.vop = payload.plate || payload.vin;
            state.isPlateless = false;
            state.car = payload;
            state.isCarConfirmed = true;
            state.isOwnerConfirmed = true;
            state.isCertUploaded = false;
            state.isDone = false;
        },
    },
    extraReducers: builder => {
        const { vehicle, singleCar, createCarAndOwner } = API.endpoints;

        builder
            .addMatcher(
                isAnyOf(vehicle.matchFulfilled, singleCar.matchFulfilled),
                (state, { payload, meta }) => {
                    state.vop = meta.arg.originalArgs.plate_or_vin;
                    state.car = payload;
                },
            )
            .addMatcher(createCarAndOwner.matchFulfilled, (state, { payload }) => {
                state.vop = null;
                state.isPlateless = true;
                state.car = payload;
                state.isCarConfirmed = true;
                state.isOwnerConfirmed = true;
            })
            .addMatcher(
                isAnyOf(vehicle.matchRejected, singleCar.matchRejected),
                (state, { meta }) => {
                    state.vop = meta.arg.originalArgs.plate_or_vin;
                    state.car = null;
                },
            );
    },
});

export const {
    reset,
    resetVOP,
    setIsPlateless,
    setIsCarConfirmed,
    setIsOwnerConfirmed,
    setIsCertUploaded,
    setIsDone,
    recycleIncomingCar,
} = operatorRecycleSlice.actions;

export default operatorRecycleSlice.reducer;
